module.exports = __webpack_public_path__ + "assets/ec3d2df45c595036601202e60ce6ef77.mp3";